$(window).on('load', function () {
    setTimeout(function () {
        $('.preloader').fadeOut('slow', function () {
            $('#loader').fadeOut('slow');
        });
    }, 500);
});
